import { gql } from "@outschool/ui-apollo";

import { ListingCardFragment } from "./fragments";

export default gql`
  query ListingsByActivityUids(
    $activityUids: [ID!]!
    $skipRating: Boolean!
    $withRecentReviews: Boolean!
  ) {
    listingsByActivityUids(activityUids: $activityUids) {
      ...ListingCard_listing
    }
  }
  ${ListingCardFragment}
`;
